// import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import PainelPS from './PainelPS'
import PainelPSBoxHorizontal from './PainelPSBoxHorizontal'
import PainelRadiologia from './PainelRadiologia'
import PainelAutorizacao from './PainelAutorizacao'
import PainelCentroCirurgico from './PainelCentroCirurgico'
import PainelCentroCirurgicoPrivado from './PainelCentroCirurgicoPrivado'
import PainelLaboratorioFast from './PainelLaboratorioFast'
import PainelLaboratorio from './PainelLaboratorio'
import PainelParecerPendente from './PainelParecerPendente'
import PainelParecerPendentePS from './PainelParecerPendentePS'
import PainelDispensacaoUrgencia from './PainelDispensacaoUrgencia'
import PainelAltaMedica from './PainelAltaMedica'
import PainelAltaMedicaParticular from './PainelAltaMedicaParticular'
import PainelAltaTransferencia from './PainelAltaTransferencia'
import PainelAltaTransferenciaNew from './PainelAltaTransferenciaNew'
import PainelPacotes from './PainelPacotes'
import PainelRN from './PainelRN'
import PainelInternacao from './PainelInternacao'
import { createBrowserHistory } from "history";
import PainelPSProbabilidadeInternacao from "./PainelPSProbabilidadeInternacao";
import PainelUTIProbabilidadeInternacao from "./PainelUTIProbabilidadeInternacao";
import PainelAcompanhamentoOPME from "./PainelAcompanhamentoOPME";
import PainelLeitosManutencao from "./PainelLeitosManutencao";
import PainelPacientesDietaZero from "./PainelPacientesDietaZero";
import PainelPacientesLiberacaoDieta from "./PainelPacientesLiberacaoDieta";
import PainelPSMonitoramento from "./PainelPSMonitoramento";
import PainelAguardandoInternacao from "./PainelAguardandoInternacao";

const hist = createBrowserHistory();

function App() {
  // render() {
  return (
    <Router history={hist}>
      <Switch>
        <Route exact path="/painel/ps/:base/:company/:theme?" component={PainelPS} />
        {/* when none of the above match, <NoMatch> will be rendered */}
      </Switch>
      <Switch>
        <Route exact path="/painel/internacao/:base/:company/:unidade" component={PainelInternacao} />
        {/* when none of the above match, <NoMatch> will be rendered */}
      </Switch>
      <Switch>
        <Route exact path="/painel/ps-horizontal/:base/:company?/:theme?" component={PainelPSBoxHorizontal} />
        {/* when none of the above match, <NoMatch> will be rendered */}
      </Switch>
      <Switch>
        <Route exact path="/painel/pacotes/:base/:company/:theme?" component={PainelPacotes} />
        {/* when none of the above match, <NoMatch> will be rendered */}
      </Switch>
      <Switch>
        <Route exact path="/painel/autorizacao/:base/:company/:theme?" component={PainelAutorizacao} />
        {/* when none of the above match, <NoMatch> will be rendered */}
      </Switch>
      <Switch>
        <Route exact path="/painel/aguardando-internacao/:base/:empresas?/:theme?" component={PainelAguardandoInternacao} />
        {/* when none of the above match, <NoMatch> will be rendered */}
      </Switch>
      <Switch>
        <Route exact path="/painel/radiologia/:base/:company/:theme?" component={PainelRadiologia} />
        {/* when none of the above match, <NoMatch> will be rendered */}
      </Switch>
      <Switch>
        <Route exact path="/painel/laboratorio-fast/:base/:company/:theme?" component={PainelLaboratorioFast} />
        {/* when none of the above match, <NoMatch> will be rendered */}
      </Switch>
      <Switch>
        <Route exact path="/painel/laboratorio/:base/:company/:theme?" component={PainelLaboratorio} />
        {/* when none of the above match, <NoMatch> will be rendered */}
      </Switch>
      <Switch>
        <Route exact path="/painel/alta-medica-particular/:base/:company/:theme?" component={PainelAltaMedicaParticular} />
        {/* when none of the above match, <NoMatch> will be rendered */}
      </Switch>
      <Switch>
        <Route exact path="/painel/alta-medica/:base/:company/:theme?" component={PainelAltaMedica} />
        {/* when none of the above match, <NoMatch> will be rendered */}
      </Switch>
      <Switch>
        <Route exact path="/painel/alta-transferencia/:base/:company/:theme?" component={PainelAltaTransferenciaNew} />
        {/* when none of the above match, <NoMatch> will be rendered */}
      </Switch>
      <Switch>
        <Route exact path="/painel/alta-transferencia-new/:base/:company/:theme?" component={PainelAltaTransferenciaNew} />
        {/* when none of the above match, <NoMatch> will be rendered */}
      </Switch>
      <Switch>
        <Route exact path="/painel/parecer/:base/:company?/:theme?" component={PainelParecerPendente} />
        {/* when none of the above match, <NoMatch> will be rendered */}
      </Switch>
      <Switch>
        <Route exact path="/painel/parecer-ps/:base/:company?" component={PainelParecerPendentePS} />
        {/* when none of the above match, <NoMatch> will be rendered */}
      </Switch>
      <Switch>
        <Route exact path="/painel/centro-cirurgico-privado/:base/:company?" component={PainelCentroCirurgicoPrivado} />
        {/* when none of the above match, <NoMatch> will be rendered */}
      </Switch>
      <Switch>
        <Route exact path="/painel/centro-cirurgico/:base/:company/:theme?" component={PainelCentroCirurgico} />
        {/* when none of the above match, <NoMatch> will be rendered */}
      </Switch>
      <Switch>
        <Route exact path="/painel/leitos-manutencao/:base/:company?/:theme?" component={PainelLeitosManutencao} />
        {/* when none of the above match, <NoMatch> will be rendered */}
      </Switch>
      <Switch>
        <Route exact path="/painel/rn/:base/:company/:theme?" component={PainelRN} />
        {/* when none of the above match, <NoMatch> will be rendered */}
      </Switch>
      <Switch>
        <Route exact path="/painel/dispensacao-urgencia/:base/:company/:theme?" component={PainelDispensacaoUrgencia} />
        {/* when none of the above match, <NoMatch> will be rendered */}
      </Switch>
      <Switch>
        <Route exact path="/painel/ps-probabilidade-internacao/:locais?/:theme?" component={PainelPSProbabilidadeInternacao} />
        {/* when none of the above match, <NoMatch> will be rendered */}
      </Switch>
			<Switch>
				<Route exact path="/painel/uti-probabilidade-internacao/:locais?/:theme?" component={PainelUTIProbabilidadeInternacao} />
				{/* when none of the above match, <NoMatch> will be rendered */}
			</Switch>
      <Switch>
        <Route exact path="/painel/acompanhamento-opme/:idLocal?/:theme?" component={PainelAcompanhamentoOPME} />
        {/* when none of the above match, <NoMatch> will be rendered */}
      </Switch>
      <Switch>
        <Route exact path="/painel/pacientes-dieta-zero/:idLocal?/:theme?" component={PainelPacientesDietaZero} />
        {/* when none of the above match, <NoMatch> will be rendered */}
      </Switch>
      <Switch>
        <Route exact path="/painel/pacientes-liberacao-dieta/:idLocal?/:theme?" component={PainelPacientesLiberacaoDieta} />
        {/* when none of the above match, <NoMatch> will be rendered */}
      </Switch>
      <Switch>
        <Route exact path="/painel/ps-monitoramento/:base/:company" component={PainelPSMonitoramento} />
        {/* when none of the above match, <NoMatch> will be rendered */}
      </Switch>
    </Router>
  );
  // }
}

export default App;
